import { useRouter } from "next/router";
function StartPage() {
  var _useRouter = useRouter(),
    replace = _useRouter.replace;
  replace("/search/quick");
  return null;
}
export default StartPage;